// eslint-disable-next-line import/no-self-import
import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

const { go, back, push, replace, action, createHref, forward, location } = history;
export { go, back, push, replace, action, createHref, forward, location };
export default history;
